import { EnumButtonName } from '@calm/evexia-analytics';
import { VolumeIcon } from '@rhg/components/media/volume-icon';
import { useAudio } from '@rhg/hooks/use-audio';
import playerMessages from '@rhg/lang/messages/player';
import {
    IconButton,
    IconButtonProps,
    SxProps,
    Theme,
} from '@rhg/libs/material';
import { useIntl } from 'react-intl';

export interface MuteButtonProps {
    sx?: SxProps<Theme>;
    size?: IconButtonProps['size'];
    variant?: IconButtonProps['variant'];
}

export function MuteButton({ sx, size, variant }: MuteButtonProps) {
    const { formatMessage } = useIntl();
    const {
        controls: { isMuted, toggleMuted },
    } = useAudio();

    return (
        <IconButton
            trackButton={
                isMuted
                    ? EnumButtonName.AudioPlayerUnmute
                    : EnumButtonName.AudioPlayerMute
            }
            onClick={() => toggleMuted()}
            aria-label={
                isMuted
                    ? formatMessage(playerMessages['player.unmute'])
                    : formatMessage(playerMessages['player.mute'])
            }
            size={size}
            variant={variant}
            sx={sx}
        >
            <VolumeIcon isMuted={isMuted} />
        </IconButton>
    );
}
